// extracted by mini-css-extract-plugin
export var bg = "Sustainable-module--bg--b1781";
export var core = "Sustainable-module--core--4e537";
export var text = "Sustainable-module--text--3f441";